var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCandles = function SvgCandles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    color: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9v6c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C8.398 18 7.932 18 7 18s-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C4 16.398 4 15.932 4 15V9c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C5.602 6 6.068 6 7 6s1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C10 7.602 10 8.068 10 9m10 5v1c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C18.398 18 17.932 18 17 18s-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C14 16.398 14 15.932 14 15v-1c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C15.602 11 16.068 11 17 11s1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C20 12.602 20 13.068 20 14m-3-3V3m0 15v3M7 6V3m0 15v3"
  })));
};
export default SvgCandles;